import React from 'react'

const LenderControl = () => {
  return (
    <section id="c-sectionYouInControl" className="c-sectionWrapper">
		<div className="container">
			<div className="row">
				<div className="col-sm-12 col-lg-5 c-yicImgCol">				
					<img src="./images/lender/yic_main_image.png" className="img-fluid" alt="" title="" />
				</div>
				<div className="col-sm-12 col-lg-7 c-yicHeaderBoxesCol">
					<div className="c-sectionHeader">
						<h5 className="c-heading46Bold">You're in control</h5>												
						{/* <!-- <p className="c-para22Regular">Lorem Ipsum is simply dummy text of the printing and type and setting industry Lorem Ipsum is simply</p> --> */}
						<img src="./images/lender/yic_main_image.png" className="img-fluid c-yicImgColHeader" alt="" title="" />
					</div>

					<div className="c-yicBoxes">
						<div className="c-yicBox">
							<div className="c-yicBoxIcon">
								<img src="./images/lender/yic_icon_1.png" alt="" title="" />
							</div>
							<div className="c-yicBoxInfo">
								<div className="c-yicBoxTitle">Configure your recommendation Engine</div>
								<div className="c-yicBoxPara">Through the recommendation engine lenders can choose their borrower as per their credit policies.</div>
							</div>
						</div>
						<div className="c-yicBox">
							<div className="c-yicBoxIcon">
								<img src="./images/lender/yic_icon_2.png" alt="" title="" />
							</div>
							<div className="c-yicBoxInfo">
								<div className="c-yicBoxTitle">Supervise your Finance Strategy </div>
								<div className="c-yicBoxPara">Configure prices to manage your preferred return on assets.</div>
							</div>
						</div>
						<div className="c-yicBox">
							<div className="c-yicBoxIcon">
								<img src="./images/lender/yic_icon_3.png" alt="" title="" />
							</div>
							<div className="c-yicBoxInfo">
								<div className="c-yicBoxTitle">Leverage AI to predict default</div>
								<div className="c-yicBoxPara">Our model calculates the possibility and timing of default to help you to operate within your risk desire.</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
  )
}

export default LenderControl